import * as React from 'preact/compat'
import cn from 'classnames'
import SVG from '../SVG'
import type { SeriesInfoInterface } from './types'
import styles from '../../../css/compilation-card.pcss.json'
import { loadStylesheet } from '../../common/helpers'
import type { ImgHTMLAttributes } from 'preact/compat'

export default ({ series, onClick, type, overlay, linkPostfix, size }: {
  series: SeriesInfoInterface,
  onClick?: (series: SeriesInfoInterface) => void
  type?: 'button' | 'link' | 'plain',
  overlay?: React.JSX.Element,
  linkPostfix?: string,
  size?: number
}) => {

  React.useEffect(() => {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('compilation-card')
  })

  type = type || 'plain'

  const buttonRef = React.useRef<HTMLButtonElement>(null)

  const imgProps: ImgHTMLAttributes<HTMLImageElement> = {}

  if (size) {
    imgProps.width = size
    imgProps.height = size
  }

  const content = <>
    <div className={styles['card__inner']}>
      {series.square_poster
        && <img alt='' src={series.square_poster} className={styles['background']} draggable={false} {...imgProps} />
      }
      <div className={styles['card__shadow']}/>
      {overlay || <div className={styles['counts']}>
        <span><SVG i='sg/gamepad-solid'/> {series.games_count}</span>
      </div>}
      <div className={styles['card__bottom']}>
        <span className={styles['title']}>{series.name}</span>
      </div>
    </div>
    <div className={styles['shadow-1']}></div>
    <div class={styles['shadow-2']}></div>
  </>

  if (type === 'button') {
    if (!onClick) {
      throw new Error('GameSeries type \'button\' requires \'add\' prop');
    }

    const addSeries = (e: React.TargetedEvent<HTMLButtonElement>) => {
      e.preventDefault()
      onClick(series)
    }

    return <button
      type='button'
      onClick={addSeries}
      className={cn({
        [`${styles['card']}`]: true
      })}
      ref={buttonRef}
    >
      {content}
    </button>
  }

  if (type === 'link') {
    return <a
      href={`/game-series/${series.id}/${series.slug}${linkPostfix}`}
      className={styles['card']}
      draggable={false}
    >
      {content}
    </a>
  }

  return <div className={styles['card']}>
    {content}
  </div>
}
